import { createSlice } from "@reduxjs/toolkit";
import {
  AddIMCTime,
  createUpdateImc,
  deleteIMCTime,
  downLoadImcReport,
  downLoadImcReportDatewise,
  downLoadImcReportInCSVDatewise,
  downLoadImcReportInXLXDatewise,
  EditIMCTime,
  fetchImcAuditTrailList,
  fetchImcList,
  sendImcReportToShrewd,
  toggleIMCTimeActivation,
} from "../actions/imcAction";

export const imcs = createSlice({
  name: "imcs",
  initialState: {
    auditTrails: null,
    returnList: null,
    data: null,
    imcs: null,
    filePath: null,
    updatedAt: null,
    downloadFileOfCurrentDate: null,
    downloadFileOfDate: null,
    downloadXlsxFileOfDate: null,
    downloadCsvFileOfDate: null,
    emailReport: null,
    error: null,
    sortBy: null,
    isLoader: false,
    isDownloadLoader: false,
    isRecordAdded: false,
    isRecordUpdated: false,
    isRecordLoaded: false,
    isManageWardPage: false,
    sendToShrewdResponse: null,
    isSendToShrewdClicked: false,
  },
  reducers: {
    userReset: (state) => {
      // state.imcs= null;
      state.error = null;
    },
    resetPopup: (state) => {
      state.isLoader = false;
      state.isDownloadLoader = false;
      state.isRecordAdded = false;
      state.isRecordUpdated = false;
      state.error = null;
      state.sendToShrewdResponse = null;
      state.isSendToShrewdClicked = false;
    },
    setManageWardPage: (state) => {
      state.isManageWardPage = true;
    },
    resetManageWardPage: (state) => {
      state.isManageWardPage = false;
    },
  },
  extraReducers: {
    [fetchImcList.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [fetchImcList.fulfilled]: (state, { payload }) => {
      state.error = null;
      return {
        ...state,
        ...payload?.data,
        isLoader: false,
        isDownloadLoader: false,
      };
    },
    [fetchImcList.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },

    [fetchImcAuditTrailList.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [fetchImcAuditTrailList.fulfilled]: (state, { payload }) => {
      state.error = null;
      return {
        ...state,
        ...payload?.data,
        isLoader: false,
      };
    },
    [fetchImcAuditTrailList.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },

    [createUpdateImc.pending]: (state, payload) => {
      state.error = null;
      state.isRecordAdded = false;
      state.isRecordUpdated = false;
      state.isLoader = true;
    },
    [createUpdateImc.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.isRecordAdded = true;
      state.isRecordUpdated = true;
      state.isLoader = false;
      state.isDownloadLoader = false;
    },
    [createUpdateImc.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isRecordAdded = false;
      state.isRecordUpdated = false;
      state.isLoader = false;
    },

    [downLoadImcReportDatewise.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [downLoadImcReportDatewise.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.downloadFileOfDate = payload?.data?.filePath;
      state.isDownloadLoader = false;
      state.isLoader = false;
    },
    [downLoadImcReportDatewise.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },
    // xlsx datewise report donwload
    [downLoadImcReportInXLXDatewise.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [downLoadImcReportInXLXDatewise.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.downloadXlsxFileOfDate = payload?.data;
      state.isDownloadLoader = false;
      state.isLoader = false;
    },
    [downLoadImcReportInXLXDatewise.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },
    // csv datewise report donwload
    [downLoadImcReportInCSVDatewise.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [downLoadImcReportInCSVDatewise.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.downloadCsvFileOfDate = payload?.data;
      state.isDownloadLoader = false;
      state.isLoader = false;
    },
    [downLoadImcReportInCSVDatewise.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },
    //
    [downLoadImcReport.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [downLoadImcReport.fulfilled]: (state, { payload }) => {
      state.error = null;
      console.log("payload", payload);
      state.downloadFile = payload?.data?.filePath;
      console.log("state.downloadFile", state.downloadFile);
      state.isDownloadLoader = false;
      state.isLoader = false;
    },
    [downLoadImcReport.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },

    // send email report to shrewd
    [sendImcReportToShrewd.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
      state.isDownloadLoader = true;
    },
    [sendImcReportToShrewd.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.isDownloadLoader = false;
      state.sendToShrewdResponse = payload;
      state.isSendToShrewdClicked = true;
      state.isLoader = false;
    },
    [sendImcReportToShrewd.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
      state.isDownloadLoader = false;
    },

    // imc auto report scheduler
    [AddIMCTime.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [AddIMCTime.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.isLoader = false;
      state.isRecordUpdated = true;
    },
    [AddIMCTime.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },
    [EditIMCTime.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [EditIMCTime.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.isLoader = false;
      state.isRecordUpdated = true;
    },
    [EditIMCTime.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },
    [deleteIMCTime.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [deleteIMCTime.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.isLoader = false;
      state.isRecordUpdated = true;
    },
    [deleteIMCTime.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },
    [toggleIMCTimeActivation.pending]: (state, payload) => {
      state.error = null;
      state.isLoader = true;
    },
    [toggleIMCTimeActivation.fulfilled]: (state, { payload }) => {
      state.error = null;
      state.isLoader = false;
      state.isRecordUpdated = true;
    },
    [toggleIMCTimeActivation.rejected]: (state, { payload }) => {
      state.error = payload;
      state.isLoader = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  userReset,
  userSort,
  userSearch,
  resetPopup,
  setManageWardPage,
  resetManageWardPage,
} = imcs.actions;

export default imcs.reducer;
